import React from 'react'
import { inject, observer } from 'mobx-react'
import { ComponentExt } from 'util/reactExt'
import { RouteComponentProps } from 'react-router-dom'
import { Input, Button, Form, Modal, Tabs, Pagination, Icon } from 'antd'
// import Cate from 'components/layout/CateLayout'
import Preview from 'containers/shared/CoursePreview'
import Card from 'components/Card'
import styles from './index.scss'
import { FormComponentProps } from '../../../../../node_modules/antd/lib/form'

const Search = Input.Search
const TabPane = Tabs.TabPane

const confirm = Modal.confirm

interface IUCollectionProps extends RouteComponentProps<any> {}

@inject('globalStore')
@observer
class UCollection extends ComponentExt<IUCollectionProps> {
  state = {
    current: -1,
    folderList: [],
    collectionData: { data: [], total: 0 },
    pageindex: 1,
    collectModal: false,
    keyword: '',
    addPanel: false,
    isEdit: false,
    isPreivew: false,
    previewData: {},
  }

  async componentDidMount() {
    await this.fetchUserCollectionFolder()
    if (this.state.folderList.length) {
      this.fetchFolderCollction(this.state.current, 1)
    }
  }

  async fetchUserCollectionFolder() {
    const { current: oldCurrent, folderList } = this.state
    const res = await this.api.collect.collectList()

    const current = folderList.length
      ? folderList.findIndex(
          folder => Number(folder.collect_folder_id) === Number(oldCurrent),
        ) > 0
        ? oldCurrent
        : res[0].collect_folder_id
      : -1

    this.setState({
      current,
      folderList: res,
    })
  }

  async fetchFolderCollction(id, pageindex) {
    const res = await this.api.collect.collectDataList(id, {
      pageindex,
      pagesize: 9,
    })
    this.setState({
      collectionData: res,
    })
  }

  async searchUserCollection(keyword, pageindex) {
    const res = await this.api.collect.searchUserCollection(keyword, {
      pageindex,
      pagesize: 9,
    })

    this.setState({
      collectionData: res,
    })
  }

  get CurrentFolderName() {
    return this.state.folderList.find(
      item => Number(item.collect_folder_id) === Number(this.state.current),
    ).folder_name
  }

  handlePageChange = index => {
    const { current, keyword } = this.state
    current === -1
      ? this.searchUserCollection(keyword, index)
      : this.fetchFolderCollction(current, index)
    this.setState({
      pageindex: index,
    })
  }

  handleTabClick(e) {
    this.fetchFolderCollction(e, 1)
    this.setState({
      current: e,
      pageindex: 1,
    })
  }

  handleSearch(value) {
    this.setState({
      current: -1,
      pageindex: 1,
    })

    this.searchUserCollection(value, 1)
  }

  showDeleteConfirm = id => {
    confirm({
      title: '确认删除该收藏夹吗？',
      content: '删除文件夹会删除该文件夹下所有的视频',
      okText: '确认',
      okType: 'danger',
      cancelText: '取消',
      onOk: () => {
        this.handleDeleteFolder(id)
      },
      onCancel() {},
    })
  }

  async handleDeleteFolder(id) {
    const { current, pageindex } = this.state

    try {
      const res = await this.api.collect.deleteCollectionFolder(id)

      if (res.status === 200) {
        this.$message.success('删除成功')
      } else {
        this.$message.error('删除失败，请稍后再试')
        throw new Error(res.message)
      }
    } catch (e) {
      this.$message.error('删除失败，请稍后再试')
      throw new Error(e)
    }

    await this.fetchUserCollectionFolder()
    this.fetchFolderCollction(current, pageindex)
  }

  async fetchDetail(id) {
    try {
      const { data } = await this.api.course.getArticleDetail(id)
      this.setState({
        previewData: data,
        isPreivew: true,
      })
    } catch (err) {
      console.error(err)
    }
  }

  toDetail = (id, type, content?) => {
    if (type === '1000104') {
      return window.open(`#/topicdetail/${id}`, '_blank')
    }
    if (type === '1000105') {
      return window.open(content, '_blank')
    }
    if (type.indexOf('1100') >= 0) {
      return this.fetchDetail(id)
    }
    window.open(`#/course/${id}?type=${type}`)
  }

  handleCancelCollection(e, id, type) {
    e.stopPropagation()
    if (type.indexOf('1100') >= 0) {
      this.api.course.cancelFavorite(id, type).then(res => {
        if (res.status !== 200) {
          return this.$message.error('取消收藏失败')
        }
        this.$message.success('取消收藏成功')
        const { current, pageindex } = this.state
        this.fetchUserCollectionFolder()
        this.fetchFolderCollction(current, pageindex)
      })
      return
    }
    this.cancelCollection(id, type)
  }

  cancelCollection = async (id, type) => {
    const { current, pageindex } = this.state
    const res = await this.api.collect.cancelFavorite(id, type)
    if (res.status === 200) {
      this.$message.success('取消收藏成功')
      this.fetchUserCollectionFolder()
      this.fetchFolderCollction(current, pageindex)
    } else {
      this.$message.error('取消收藏失败')
    }
  }

  renderHandleBar = () => {
    const { folderList, current } = this.state

    const operations = (
      <div className={styles.operations}>
        <Search
          className={styles.searchBar}
          placeholder="搜索收藏夹内容"
          onSearch={value => this.handleSearch(value.trim())}
        />
        <div className={styles.btnGroup}>
          <Button
            onClick={e => this.handleEdit(e, 1)}
            style={{ width: 76, height: 32, marginRight: 24 }}
            disabled={current === -1}
          >
            编辑
          </Button>
          <Button
            onClick={this.handleModal}
            style={{ height: 32 }}
            icon="plus"
            type="primary"
          >
            新建收藏
          </Button>
        </div>
      </div>
    )

    return (
      <Tabs
        activeKey={current.toString()}
        onChange={e => this.handleTabClick(e)}
        tabBarExtraContent={operations}
      >
        {folderList.map(folder => (
          <TabPane
            tab={
              <div className={styles.folderItem}>
                <span>{`${folder.folder_name} (${folder.collect_count})`}</span>
                {Number(folder.collect_folder_id) === Number(current) && (
                  <Icon
                    onClick={() => this.showDeleteConfirm(Number(current))}
                    className={styles.folderItemDelete}
                    type="close-circle"
                    style={{
                      color: 'red',
                      position: 'absolute',
                      right: '-23px',
                      top: '0',
                    }}
                  />
                )}
              </div>
            }
            key={folder.collect_folder_id.toString()}
          />
        ))}
      </Tabs>
    )
  }

  closeModal = () =>
    this.setState({ addPanel: false, isEdit: false, swapId: undefined })

  saveFolder = async (val, id?) => {
    try {
      const data = await this.api.collect.saveFavorite(id, val)
      this.$message.success(data || '添加成功')
      this.closeModal()
      this.fetchUserCollectionFolder()
    } catch (err) {
      console.error(err)
      this.$message.error('操作失败')
    }
  }

  handleModal = () => this.setState({ addPanel: true })

  handleEdit = (e, id) => {
    e.stopPropagation()
    this.setState({
      swapId: id,
      addPanel: true,
      isEdit: true,
    })
  }

  cancelModal = () => this.setState({ isPreivew: false })

  render() {
    const { collectionData, pageindex, isEdit, addPanel } = this.state

    const addForm = ({
      form: { getFieldDecorator, validateFields },
    }: FormComponentProps) => {
      const catchInput = e => {
        e.preventDefault()
        validateFields((err, val) => {
          if (err) {
            return
          }
          this.saveFolder(
            val.text,
            isEdit ? Number(this.state.current) : undefined,
          )
        })
      }

      return (
        <Form onSubmit={catchInput}>
          <Form.Item className={styles.collectInput}>
            {getFieldDecorator('text', {
              initialValue: isEdit && this.CurrentFolderName,
              rules: [{ required: true, message: '请输入收藏夹名称！' }],
            })(<Input placeholder="请输入收藏夹名称！" />)}
          </Form.Item>
          <Form.Item className={styles.collectBtn}>
            <Button htmlType="submit" size="large" type="primary">
              {`确认${isEdit ? '修改' : '创建'}`}
            </Button>
          </Form.Item>
        </Form>
      )
    }

    const addModal = () => {
      const CForm = Form.create()(addForm)
      return (
        <Modal
          visible={addPanel}
          onCancel={this.closeModal}
          title={`${isEdit ? '编辑' : '创建'}收藏夹`}
          footer={null}
          style={{ top: '30%', maxWidth: 460 }}
          bodyStyle={{ padding: 0 }}
          destroyOnClose
        >
          <CForm />
        </Modal>
      )
    }

    const modalRender = info => (
      <Modal
        title={info.title || ''}
        visible={this.state.isPreivew}
        width={1000}
        style={{ top: '5%' }}
        onCancel={this.cancelModal}
        footer={null}
        bodyStyle={{ padding: 0 }}
      >
        <Preview info={info as any} />
      </Modal>
    )

    return (
      <div className={styles.userCollection}>
        <h3 className={styles.handleBar}>{this.renderHandleBar()}</h3>
        <section style={{ backgroundColor: '#fff', padding: '32px 0' }}>
          <div
            style={{
              display: 'flex',
              padding: '0 16px',
              flexWrap: 'wrap',
              overflow: 'hidden',
              minHeight: '400px',
            }}
          >
            {collectionData.total > 0 ? (
              collectionData.data.map(
                (
                  {
                    id,
                    img_url,
                    title,
                    view_count,
                    type,
                    course_time,
                    content,
                    courseware_url,
                  },
                  idx,
                ) => (
                  <div className={styles.collectCard}>
                    <Card
                      key={`fccard-${idx}`}
                      cover={img_url}
                      title={title}
                      type="middle"
                      watch={view_count}
                      time={course_time}
                      onClick={() => this.toDetail(id, type, content)}
                      collect={true}
                      style={{ marginBottom: 48, marginRight: 12 }}
                    />
                    <i onClick={e => this.handleCancelCollection(e, id, type)}>
                      <Icon type="delete" />
                    </i>
                  </div>
                ),
              )
            ) : (
              <div
                style={{
                  margin: '0 auto',
                  lineHeight: '400px',
                  height: '400px',
                }}
              >
                暂无收藏
              </div>
            )}
          </div>
          <div style={{ textAlign: 'center' }}>
            <Pagination
              hideOnSinglePage={true}
              pageSize={9}
              total={collectionData.total}
              current={pageindex}
              onChange={this.handlePageChange}
            />
          </div>
        </section>
        {addModal()}
        {modalRender(this.state.previewData)}
      </div>
    )
  }
}

export default UCollection
